import { normalize } from "normalizr"
import { call, put, takeLeading } from "redux-saga/effects"
import API from "../../../../apis/contextmeeting/api"
import { fetchChatsSchema } from "../../../../apis/contextmeeting/schema"
import { withAuthHeader } from "../../../../apis/contextmeeting/withAuthHeader"
import { displayUserMessageAction } from "../../../userMessage/state/userMessageActions"
import { UserMessageTypes } from "../../../userMessage/state/userMessageTypes"
import { ChatActionTypes, IToggleMutedChatAsyncAction } from "../chatTypes"

export function* toggleMutedChatAsync(action: IToggleMutedChatAsyncAction): Generator {
  try {
    const chatId = action.payload

    const response: any = yield call(API.patch, `/chats/${chatId}/toggle_muted`, {}, withAuthHeader())

    const normalizedResponse = normalize(response.data, fetchChatsSchema)

    yield put({
      type: ChatActionTypes.TOGGLE_MUTED_CHAT_ASYNC_SUCCESS,
      payload: normalizedResponse
    })
  } catch (error) {
    yield put({
      type: ChatActionTypes.TOGGLE_MUTED_CHAT_ASYNC_ERROR,
      payload: error
    })

    yield put(displayUserMessageAction({
      messageKey: "toggleMutedChatFail",
      type: UserMessageTypes.ERROR
    }))
  }
}

export function* watchToggleMutedChatAsync(): Generator {
  yield takeLeading(ChatActionTypes.TOGGLE_MUTED_CHAT_ASYNC_PENDING, toggleMutedChatAsync)
}
